import { useState, useEffect } from "react";

const useScrollSpy = (headingIds, rootMargin = "0px 0px -80% 0px") => {
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    if (!headingIds || headingIds.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        // Filter visible entries
        const visibleEntries = entries.filter((entry) => entry.isIntersecting);

        if (visibleEntries.length > 0) {
          // Pick the heading with the **largest intersection ratio**
          const mostVisible = visibleEntries.reduce((prev, current) =>
            prev.intersectionRatio > current.intersectionRatio ? prev : current
          );
          setActiveId((prev) => {
            if (prev !== mostVisible.target.id) return mostVisible.target.id;
            return prev;
          });
        }
      },
      {
        rootMargin,
        threshold: Array.from({ length: 11 }, (_, i) => i / 10), // 0,0.1,...1
      }
    );

    headingIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [headingIds, rootMargin]);

  return activeId;
};

export default useScrollSpy;
